import { FunctionalComponent } from 'preact';

type Props = {
  type: string;
  url?: string;
};

const NotFound: FunctionalComponent<Props> = ({ type, url = '' }) => (
  <section>
    <h2>
      Error
      {type}
    </h2>
    <p>It looks like we hit a snag.</p>
    <pre>{url}</pre>
  </section>
);

export default NotFound;
